import { API } from '~/api/api';
import type { RequestParams } from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';

export async function getCategories(
  category_id: string,
  params: RequestParams
) {
  try {
    const res = await API.get(`/categories/${category_id}`, params);
    const globalStore = useGlobalStore();
    globalStore.setPerPageListingValue(res?.data?.per_page);
    return res.data;
  } catch (error) {
    return null;
  }
}
